import { render, staticRenderFns } from "./AttachmentListItem.vue?vue&type=template&id=79fab032&"
import script from "./AttachmentListItem.vue?vue&type=script&lang=js&"
export * from "./AttachmentListItem.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentListItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports